import React from 'react';
import styles from './StepperHeader.module.css';

interface StepperStepProps {
  number: number;
  label: string;
  status: 'active' | 'current' | 'inactive';
  showIcon?: boolean;
}

const StepperStep: React.FC<StepperStepProps> = ({ number, label, status, showIcon }) => {
  const buttonClass = `${styles.stepButton} ${
    status === 'active'
      ? styles.stepButtonActive
      : status === 'current'
      ? styles.stepButtonCurrent
      : styles.stepButtonInactive
  }`;

  const labelClass = `${styles.stepLabel} ${
    status === 'inactive' ? styles.stepLabelInactive : styles.stepLabelActive
  }`;

  return (
    <div className={styles.stepperStep}>
      <div className={buttonClass}>{number}</div>
      <div className={labelClass}>{label}</div>
      {showIcon && (
        <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/45b746d27326b2d4339bdf2cd63b00737d09488703c6cca9ac1023e4ab6e9729?placeholderIfAbsent=true&apiKey=56a6c7500c3c464580ff9be9a9daa1d9" className={styles.stepIcon} alt="" />
      )}
    </div>
  );
};

export default StepperStep;